import { render } from "./IconUploadFile.vue?vue&type=template&id=f8756ba0"
import script from "./IconUploadFile.vue?vue&type=script&lang=js"
export * from "./IconUploadFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/16/IconUploadFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8756ba0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8756ba0', __exports__)) {
    api.reload('f8756ba0', __exports__)
  }
  
  module.hot.accept("./IconUploadFile.vue?vue&type=template&id=f8756ba0", () => {
    api.rerender('f8756ba0', render)
  })

}


export default __exports__